export default __webpack_public_path__ + "static/media/NOR.7a613ae5.svg";